import React from "react";
import { useTranslation } from "react-i18next";
import Accordion from "~/components/utils/Accordion";
import SetActivation from "~/reception/SetActivation";

/**
 * Activationセクションコンポーネント
 * 他の設定セクションと同様にアコーディオン表示する
 */
const ActivationSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Accordion
      items={[
        {
          title: `${t("authenticationCodeSettings")}`,
          content: <SetActivation />,
          dynamicHeight: true,
        },
      ]}
    />
  );
};

export default ActivationSection;
